'use-strict';
function getCookie(cname) {
  let name = cname + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

function deleteCookie(cname) {
  document.cookie = cname + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function setCookie(cname, cvalue, exdays) {
  const date = new Date();
  date.setTime(date.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = 'expires=' + date.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  };
}

let parser = new DOMParser();

const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
};

let subscribers = {};
var root = document.body;

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target?.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options['hideElement'] || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    'change',
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value);
};
var getScrollBarWidth = (function () {
  return {
    init: function () {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.width = '100px';
      scrollDiv.style.height = '100px';
      scrollDiv.style.overflow = 'scroll';
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      document.body.appendChild(scrollDiv);
      var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
      return scrollbarWidth;
    },
  };
})();
function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      if (data) {
        callback(data);
      } else {
        callback();
      }
    });
  }
}
function initLazyloadItem() {
  const lazyVideos = document.querySelectorAll('video.lazy-video-item');

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const video = entry.target;
          const poster = video.dataset.poster;
          const src = video.dataset.src;

          if (poster) {
            video.setAttribute('poster', poster);
            video.removeAttribute('data-poster');
            video.setAttribute('src', src);
            video.removeAttribute('data-src');
          }

          video.querySelectorAll('source').forEach((source) => {
            const source_src = source.dataset.src;
            if (source_src) {
              source.setAttribute('src', source_src);
              source.removeAttribute('data-src');
            }
          });

          video.classList.remove('lazy-video-item');
          observer.unobserve(video); // Stop observing once loaded
        }
      });
    },
    { threshold: 0.1 }, // Trigger when 10% of the video is visible
  );

  lazyVideos.forEach((video) => observer.observe(video));
}

// Initialize lazy loading item
initLazyloadItem();

function initLazyload() {
  window.addEventListener('scroll', () => {
    scrollLazyload();
  });
  let pos = window.pageYOffset;
  if (pos > 40) {
    scrollLazyload();
  }
}
initLazyload();

function scrollLazyload() {
  document.querySelectorAll('video.lazy-video').forEach((el) => {
    scrollLazyloadItem(el);
  });
}

function scrollLazyloadItem(el) {
  const poster = el.dataset.poster;
  const src = el.dataset.src;
  if (poster) {
    el.setAttribute('poster', poster);
    el.removeAttribute('data-poster');
    el.setAttribute('src', src);
    el.removeAttribute('data-src');
  }
  el.querySelectorAll('source').forEach((source) => {
    const source_src = source.dataset.src;
    if (source_src) {
      source.setAttribute('src', source_src);
      source.removeAttribute('data-src');
    }
  });
  el.classList.remove('lazy-video');
}

/**
 * Detects if the current device is a mobile device (Android or iOS).
 * Uses a combination of User-Agent sniffing and screen/touch checks.
 *
 * @returns {boolean}
 */
function isMobileDevice() {
  // 1. User-Agent string fallback
  const ua = navigator.userAgent;
  const uaMatch =
    /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(ua);
  if (uaMatch) return true;

  // 2. narrow screen heuristic
  const isNarrow = window.innerWidth <= 567;
  if (isNarrow) return true;

  // 3. Modern API — available in Chrome 98+, Edge 98+

  if (navigator.userAgentData?.mobile !== undefined) {
    return navigator.userAgentData.mobile;
  }
  return false;
}
class CartUtils {
  /**
   * Update cart count display across all cart count elements
   * @param {number} itemCount - Number of items in cart
   */
  static updateCartCount(itemCount) {
    document.querySelectorAll('.cart-count').forEach((el) => {
      if (el.classList.contains('cart-count-drawer')) {
        el.innerHTML = `(${itemCount})`;
      } else {
        el.innerHTML = itemCount > 100 ? '~' : itemCount;
      }
    });
  }

  /**
   * Update header total price if element exists
   * @param {Object} cartData - Cart data object
   */
  static updateHeaderTotalPrice(cartData) {
    const headerTotalPrice = document.querySelector('header-total-price');
    if (
      headerTotalPrice &&
      typeof headerTotalPrice.updateTotal === 'function'
    ) {
      headerTotalPrice.updateTotal(cartData);
    }
  }

  /**
   * Update free shipping progress bar
   * @param {number} subtotalPrice - Items subtotal price
   */
  static updateFreeShippingBar(subtotalPrice) {
    // allows to update the cart free shipping progress bar
    const cartFreeShips = document.querySelectorAll('free-ship-progress-bar');
    if (cartFreeShips.length > 0) {
      cartFreeShips.forEach((item) => {
        item.init(subtotalPrice);
      });
    }
    // const cartFreeShip = document.querySelector('free-ship-progress-bar');
    // if (cartFreeShip) {
    //   cartFreeShip.init(subtotalPrice);
    // }
  }

  /**
   * Update cart totals section
   * @param {Object} sections - Parsed sections data
   * @param {string} totalsSelector - CSS selector for totals
   */
  static updateCartTotals(sections, totalsSelector = '.cart-info .totals') {
    const mainCartItems = document.getElementById('main-cart-items');
    if (!mainCartItems || !sections) return;

    const totalsHTML = CartUtils.getSectionInnerHTML(
      sections[mainCartItems.dataset.id],
      totalsSelector,
    );
    const totalsContent = document.querySelector(totalsSelector);

    if (totalsHTML && totalsContent) {
      totalsContent.innerHTML = totalsHTML;
    }
  }

  /**
   * Parse HTML section and return inner HTML
   * @param {string} html - HTML string to parse
   * @param {string} selector - CSS selector
   * @returns {string} - Inner HTML or empty string
   */
  static getSectionInnerHTML(html, selector) {
    try {
      return (
        new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector(selector)?.innerHTML || ''
      );
    } catch (error) {
      console.error('Error parsing HTML section:', error);
      return '';
    }
  }

  /**
   * Update gift form event listeners
   * @param {HTMLElement} cartInstance - Cart instance for binding methods
   */
  static updateGiftFormListeners(cartInstance) {
    const giftFormMinicart = document.getElementById('gift_form_minicart');
    if (giftFormMinicart) {
      giftFormMinicart.addEventListener('change', (event) => {
        if (event.currentTarget.checked) {
          cartInstance.addGiftwrapCartClick(giftFormMinicart);
        } else {
          cartInstance.updateQuantity(event.currentTarget.dataset.index, 0);
        }
      });
    }
  }

  /**
   * Comprehensive cart UI update after API responses
   * @param {Object} options - Update options
   * @param {Object} options.parsedState - Parsed API response
   * @param {Array} options.sectionsToRender - Sections to update
   * @param {HTMLElement} options.cartInstance - Cart instance
   * @param {string} options.totalsSelector - Totals selector
   */
  static updateCartUI({
    parsedState,
    sectionsToRender,
    cartInstance,
    totalsSelector = '.cart-info .totals',
  }) {
    // Update cart count
    if (parsedState.item_count !== undefined) {
      CartUtils.updateCartCount(parsedState.item_count);
      CartUtils.updateHeaderTotalPrice(parsedState);
    }
    // Update cart sections
    if (parsedState.item_count == 0) {
      sectionsToRender.forEach((section) => {
        const elementToReplace = document.querySelector('#main-cart-items');
        if (elementToReplace) {
          elementToReplace.innerHTML = CartUtils.getSectionInnerHTML(
            parsedState.sections[section.section],
            '#main-cart-items',
          );
        }
      });
    } else {
      sectionsToRender.forEach((section) => {
        const elementToReplace =
          document
            .getElementById(section.id)
            ?.querySelector(section.selector) ||
          document.getElementById(section.id);
        if (elementToReplace) {
          elementToReplace.innerHTML = CartUtils.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector,
          );
        }
      });

      // Update totals
      CartUtils.updateCartTotals(parsedState.sections, totalsSelector);

      // Update gift section
      CartUtils.updateGiftSection(parsedState.sections, cartInstance);
    }

    // Reinitialize components
    BlsLazyloadImg.init();
  }

  /**
   * Comprehensive cart UI update after API responses
   * @param {Object} options - Update options
   * @param {Object} options.parsedState - Parsed API response
   * @param {Array} options.sectionsToRender - Sections to update
   * @param {HTMLElement} options.cartInstance - Cart instance
   * @param {string} options.totalsSelector - Totals selector
   */
  static updateMinicartUI({
    parsedState,
    sectionsToRender,
    cartInstance,
    totalsSelector = '.cart-info .totals',
  }) {
    // Update cart count
    if (parsedState.item_count !== undefined) {
      CartUtils.updateCartCount(parsedState.item_count);
      CartUtils.updateHeaderTotalPrice(parsedState);
    }
    // Update cart sections
    if (parsedState.item_count == 0) {
      sectionsToRender.forEach((section) => {
        const elementToReplace = document.querySelector('#minicart-form');
        if (elementToReplace) {
          elementToReplace.innerHTML = CartUtils.getSectionInnerHTML(
            parsedState.sections[section.id],
            '#minicart-form',
          );
        }
      });
    } else {
      sectionsToRender.forEach((section) => {
        const elementToReplace =
          document
            .getElementById(section.id)
            ?.querySelector(section.selector) ||
          document.getElementById(section.id);
        if (elementToReplace) {
          elementToReplace.innerHTML = CartUtils.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector,
          );
        }
      });
    }

    // Reinitialize components
    BlsLazyloadImg.init();
  }

  /**
   * Update gift section
   * @param {Object} sections - Parsed sections
   * @param {HTMLElement} cartInstance - Cart instance
   */
  static updateGiftSection(sections, cartInstance) {
    const mainCartItems = document.getElementById('main-cart-items');
    if (!mainCartItems || !sections) return;

    const html = new DOMParser().parseFromString(
      sections[mainCartItems.dataset.id],
      'text/html',
    );

    const cartGiftHtml = html.getElementById('gift');
    const cartGift = document.getElementById('gift');

    if (cartGift && cartGiftHtml) {
      cartGift.innerHTML = cartGiftHtml.innerHTML;
      CartUtils.updateGiftFormListeners(cartInstance);
    }
  }

  /**
   * Show toast message with unified styling
   * @param {string} message - Message to display
   * @param {string} type - Type of toast (success/error)
   */
  static showToast(message, type = 'success') {
    const isSuccess = type === 'success';
    const iconColor = isSuccess ? '#137F24' : '#D0473E';
    const className = isSuccess
      ? 'newsletter-form__message--success success'
      : 'line-item-error-1 error';
    const modalType = isSuccess ? 'modal-success' : 'modal-error';

    const iconPath = isSuccess
      ? `<path d="m6.033 8.992 1.972 1.98 3.952-3.96"/><path d="M7.973 1.178c.565-.482 1.49-.482 2.062 0l1.293 1.113c.245.213.704.385 1.03.385h1.392c.867 0 1.579.712 1.579 1.579v1.39c0 .32.172.786.384 1.032l1.113 1.292c.483.565.483 1.49 0 2.062l-1.113 1.293a1.813 1.813 0 0 0-.384 1.03v1.392c0 .867-.712 1.579-1.58 1.579h-1.39c-.32 0-.786.172-1.031.384l-1.293 1.113c-.564.483-1.489.483-2.062 0L6.681 15.71a1.813 1.813 0 0 0-1.031-.384H4.234c-.867 0-1.579-.712-1.579-1.58v-1.398c0-.32-.172-.778-.376-1.023l-1.105-1.301c-.474-.565-.474-1.48 0-2.045L2.28 6.677c.204-.246.376-.704.376-1.023V4.247c0-.868.712-1.58 1.58-1.58H5.65c.319 0 .785-.171 1.03-.384l1.293-1.105Z"/>`
      : `<path d="M7.977 1.198c.573-.482 1.498-.482 2.054 0l1.293 1.105a1.89 1.89 0 0 0 1.039.376h1.39c.868 0 1.58.712 1.58 1.58v1.39c0 .328.171.786.376 1.031l1.105 1.293c.482.573.482 1.497 0 2.054l-1.105 1.292c-.204.246-.376.704-.376 1.031v1.391c0 .867-.712 1.58-1.58 1.58h-1.39c-.328 0-.786.171-1.031.376L10.039 16.8c-.573.483-1.497.483-2.054 0l-1.292-1.104c-.246-.205-.712-.377-1.031-.377H4.23c-.867 0-1.58-.712-1.58-1.579v-1.399c0-.319-.163-.785-.367-1.023l-1.105-1.3c-.474-.565-.474-1.481 0-2.046l1.105-1.3c.204-.246.368-.705.368-1.024V4.267c0-.868.712-1.58 1.579-1.58h1.415c.328 0 .786-.171 1.031-.376l1.301-1.113ZM7 11l4-4M11 11 7 7"/>`;

    const toastHTML = `
      <div class="mt-10 ${className} form__message inline-flex align-center" tabindex="-1">
        <svg width="18" height="18" fill="none" class="flex-auto">
          <g stroke="${iconColor}" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.3">
            ${iconPath}
          </g>
        </svg>
        <span class="ml-5">${message}</span>
      </div>
    `;

    showToast(toastHTML, 3000, modalType);
  }
  /**
   * Show toast message with unified styling
   * @param {string} message - Message to display
   * @param {string} type - Type of toast (success/error)
   */
  static showCartToast(message, type = 'success') {
    const isSuccess = type === 'success';
    const iconColor = isSuccess ? '#137F24' : '#D0473E';
    const className = isSuccess
      ? 'newsletter-form__message--success success'
      : 'line-item-error-1 error';
    const modalType = isSuccess ? 'modal-success' : 'modal-error';

    const iconPath = isSuccess
      ? `<path d="m6.033 8.992 1.972 1.98 3.952-3.96"/><path d="M7.973 1.178c.565-.482 1.49-.482 2.062 0l1.293 1.113c.245.213.704.385 1.03.385h1.392c.867 0 1.579.712 1.579 1.579v1.39c0 .32.172.786.384 1.032l1.113 1.292c.483.565.483 1.49 0 2.062l-1.113 1.293a1.813 1.813 0 0 0-.384 1.03v1.392c0 .867-.712 1.579-1.58 1.579h-1.39c-.32 0-.786.172-1.031.384l-1.293 1.113c-.564.483-1.489.483-2.062 0L6.681 15.71a1.813 1.813 0 0 0-1.031-.384H4.234c-.867 0-1.579-.712-1.579-1.58v-1.398c0-.32-.172-.778-.376-1.023l-1.105-1.301c-.474-.565-.474-1.48 0-2.045L2.28 6.677c.204-.246.376-.704.376-1.023V4.247c0-.868.712-1.58 1.58-1.58H5.65c.319 0 .785-.171 1.03-.384l1.293-1.105Z"/>`
      : `<path d="M7.977 1.198c.573-.482 1.498-.482 2.054 0l1.293 1.105a1.89 1.89 0 0 0 1.039.376h1.39c.868 0 1.58.712 1.58 1.58v1.39c0 .328.171.786.376 1.031l1.105 1.293c.482.573.482 1.497 0 2.054l-1.105 1.292c-.204.246-.376.704-.376 1.031v1.391c0 .867-.712 1.58-1.58 1.58h-1.39c-.328 0-.786.171-1.031.376L10.039 16.8c-.573.483-1.497.483-2.054 0l-1.292-1.104c-.246-.205-.712-.377-1.031-.377H4.23c-.867 0-1.58-.712-1.58-1.579v-1.399c0-.319-.163-.785-.367-1.023l-1.105-1.3c-.474-.565-.474-1.481 0-2.046l1.105-1.3c.204-.246.368-.705.368-1.024V4.267c0-.868.712-1.58 1.579-1.58h1.415c.328 0 .786-.171 1.031-.376l1.301-1.113ZM7 11l4-4M11 11 7 7"/>`;

    const toastHTML = `
      <div class="mt-10 ${className} form__message inline-flex align-center" tabindex="-1">
        <svg width="18" height="18" fill="none" class="flex-auto">
          <g stroke="${iconColor}" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.3">
            ${iconPath}
          </g>
        </svg>
        <span class="ml-5">${message}</span>
      </div>
    `;

    showCartToast(toastHTML, 3000, modalType);
  }
  /**
   * Show toast message with unified styling
   * @param {string} toastHTML - Message to display
   * @param {number} duration - toast duration
   * @param {string} customClass - css custom class
   * @param {Object} options - additional options
   * @param {Boolean} options.dedupe - prevent duplicate toast trigger within the elapse time
   */
  static showAddToCartToast(
    toastHTML,
    duration = 3000,
    customClass = '',
    options = { dedupe: true },
  ) {
    // method that comes from gloval.v.*.*.*.js
    showAddToCartToast(toastHTML, duration, customClass, {
      dedupe: options.dedupe,
    });
  }
}
